import { type Form } from '@wix/ambassador-forms-v4-form/types';
import {
  type Breakpoint,
  EXPERIMENTS,
  type FormView,
  createFormView,
  useExperiments,
  useConfig,
} from '@wix/form-fields';
import { useMemo } from 'react';

export const useFormView = (
  form: Form,
  stepId?: string,
  breakpoint?: Breakpoint,
): FormView[] => {
  const { isMobile } = useConfig();
  const experiments = useExperiments();
  const useFieldsV2 = experiments.isExperimentEnabled(
    EXPERIMENTS.USE_FIELDS_V2,
  );

  return useMemo(() => {
    return (form?.steps || [])
      .filter((step) => !stepId || stepId === step.id)
      .map((step) => {
        return createFormView({
          form,
          stepId: step.id!,
          isMobile,
          breakpoint,
          useFieldsV2,
        });
      });
  }, [form, stepId, isMobile, breakpoint, useFieldsV2]);
};
